<template>
  <v-data-table
    fixed-header
    height="55vh"
    :headers="headers"
    :items="matchedrulesdata"
    :items-per-page="10"
    dense
  >
  </v-data-table>
</template>

<script>
export default {
  name: "sanction Matched",
  data: () => ({
    highlightname: "",
    headers: [
      {
        text: "Rule Id",
        value: "rule_id",
        sortable: false,
      },
      { text: "Rule name", value: "rule_name", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Created by", value: "created_by", sortable: false },
      { text: "Created date", value: "created_date", sortable: false },
    ],
  }),
  props: {
    matchedrulesdata: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.bgprimary {
  background-color: $primary;
}
</style>
